// The credits/tokens system has been retired — AI actions are never gated
// now, so this modal is a no-op. Kept so existing render sites stay valid.

export default function TokenGateModal() {
  return null;
}
